import { generateAction } from './utils/generateAction';

//universal
import { universalActions } from './data/universal/actions';
//template
import { templateActions } from './data/template/actions';
//set
import { setActions } from './data/set/actions';
//page
import { pageActions } from './data/page/actions';
//organism
import { organismActions } from './data/organism/actions';

// __________ object of universal actions __________ //
export const customActions_universal = {
	...universalActions,
};
// __________ object of template actions __________ //
export const customActions_template = {
	...templateActions,
};
// __________ object of set actions __________ //
export const customActions_set = {
	...setActions,
};
// __________ object of page actions __________ //
export const customActions_page = {
	...pageActions,
};
// __________ object of organism actions __________ //
export const customActions_organism = {
	...organismActions,
};

// __________ generate actions with our structure __________ //
export const actions = {
	...generateAction(customActions_universal, 'universal'),
	...generateAction(customActions_template, 'template'),
	...generateAction(customActions_set, 'set'),
	...generateAction(customActions_page, 'page'),
	...generateAction(customActions_organism, 'organism'),
};
